import * as Sentry from '@sentry/browser';

const logError = (
	err: any,
	msg = 'There was an error in the application',
	...rest: Parameters<(typeof console)['error']>[1]
) => {
	// If we got an error we pass it to sentry
	if (err) {
		err = ensureError(err);
		console.error(msg, ...rest, err); // log error to console

		const isClientError =
			(String(err.code) && String(err.code).startsWith('4')) ||
			(String(err.status) && String(err.status).startsWith('4'));
		if (!isClientError) {
			Sentry.captureException(err);
		}
	}
};

function ensureError(err: unknown) {
	if (err instanceof Error) {
		return err;
	}
	if (typeof err === 'object' && err !== null) {
		Sentry.addBreadcrumb({
			category: 'logError',
			message: 'logError received object',
			level: Sentry.Severity.Log,
			data: err
		});
		const theError = new Error((err as { message?: any }).message || JSON.stringify(err)) as unknown as Error & {
			[key: string]: any;
		};
		TypedObject.keys(err).forEach(key => {
			theError[key] = err[key];
		});
		return theError;
	}

	return new Error(err?.toString());
}

/**
 * Asserts that the code where this function is called is unreachable.
 * This is intended as a safety to check if code that we are not 100% sure about is unreachable. This is especially handy for
 * anything on window or the global scope.
 * @param {string} identifier - Unique identifier for the location
 */
export const assertRemovable = (identifier?: string) => {
	const errorMessage = 'Reached code that was asserted to be unreachable' + (identifier ? `: ${identifier}` : '.');
	if (process.env.NODE_ENV === 'development') {
		console.error(errorMessage);
	}
	Sentry.captureException(new Error(errorMessage));
};

export default logError;
